import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Suikoden IV NG+ 108*" mdxType="SEO" />
    <h1 {...{
      "id": "suikoden-iv-ng"
    }}>{`Suikoden IV NG+`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Can advance text as fast as possible by holding R1 + Triangle`}</p>
    </blockquote>
    <p>{`Cutscene`}</p>
    <h3 {...{
      "id": "war-battle-first-engagement"
    }}>{`War Battle: First Engagement`}</h3>
    <p>{`Mash Triangle > `}<strong parentName="p">{`Option 2`}</strong>{` for tutorial`}<br parentName="p"></br>{`
`}{`Surrender as fast as possible`}</p>
    <p>{`Cutscene`}</p>
    <h4 {...{
      "id": "glen--katarina"
    }}>{`Glen & Katarina`}</h4>
    <ul>
      <li parentName="ul">{`1 Textbox > `}<strong parentName="li">{`Option 2`}</strong>{` for tutorial`}</li>
      <li parentName="ul">{`Defend for 4 turns`}</li>
    </ul>
    <p>{`Cutscene`}</p>
    <p>{`Mash Triangle > `}<strong parentName="p">{`Option 2`}</strong>{` to set up`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Snowe`}</strong>{`: Best Equip`}</li>
        <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Best Equip, 3x Power Ring`}</li>
        <li parentName="ul"><strong parentName="li">{`Snowe`}</strong>{`: Speed Ring`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Katarina`}</p>
    <h4 {...{
      "id": "duel-glen"
    }}>{`Duel: Glen`}</h4>
    <p>{`Attack Full Power`}</p>
    <p>{`Mash`}</p>
    <p>{`Talk to Keneth > Mash > Cutscene > Mash`}<br parentName="p"></br>{`
`}{`Talk to Jewel or Tal > Mash > Cutscene> Mash`}</p>
    <h3 {...{
      "id": "razril"
    }}>{`Razril`}</h3>
    <p><strong parentName="p">{`Hall of Knights (Training Hall)`}</strong>{` > Cutscene > 1 Textbox`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Razril Port`}</strong>{` > `}<strong parentName="p">{`Razril Main Street`}</strong>{` > Cutscene x3 Talk to people with torches`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Razril (Square)`}</strong>{` > Cutscene x2`}<br parentName="p"></br>{`
`}{`Talk to 4 Knights, don’t need to talk to Glenn and Katarina`}</p>
    <p><strong parentName="p">{`Hall of Knights`}</strong>{` > Textbox > `}<strong parentName="p">{`Option 2`}</strong>{` > Mash > Cutscene`}</p>
    <p><strong parentName="p">{`Hall of Knights`}</strong>{` > Cutscene > `}<strong parentName="p">{`Training Hall`}</strong><br parentName="p"></br>{`
`}{`Talk to Tal > 2 Textboxes > `}<strong parentName="p">{`Option 2`}</strong>{` > Take Keneth and Tal`}</p>
    <blockquote>
      <p parentName="blockquote">{`Should mash Triangle for mashing segments here`}</p>
    </blockquote>
    <h4 {...{
      "id": "battle-1"
    }}>{`Battle 1`}</h4>
    <p>{`Auto`}</p>
    <p>{`Mash > Cancel`}</p>
    <h4 {...{
      "id": "battle-2"
    }}>{`Battle 2`}</h4>
    <p>{`Lazlo > Attack 1, Snowe > Attack 2, Rest Defend`}</p>
    <p>{`Textbox > `}<strong parentName="p">{`Option 2`}</strong>{` > Turbo > `}<strong parentName="p">{`Option 2`}</strong>{` > Turbo`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Tal`}</strong>{`: Best Equip`}</li>
        <li parentName="ul"><strong parentName="li">{`Keneth`}</strong>{`: Best Equip, 1 Power Ring`}</li>
        <li parentName="ul"><strong parentName="li">{`Tal`}</strong>{`: 2 Power Ring`}</li>
        <li parentName="ul"><strong parentName="li">{`Snowe`}</strong>{`: 2 Power Ring`}</li>
      </ul>
    </Menu>
    <p>{`Go to Rune Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "attach"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Rage`}</strong>{`: Keneth`}</li>
        <li parentName="ul"><strong parentName="li">{`Double-Strike`}</strong>{`: Tal`}</li>
        <li parentName="ul"><strong parentName="li">{`Fortune`}</strong>{`: Lazlo`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Ship`}</strong>{` > Textbox > `}<strong parentName="p">{`Option 2`}</strong>{` > Turbo > `}<strong parentName="p">{`Option 1`}</strong></p>
    <h3 {...{
      "id": "world-map"
    }}>{`World Map`}</h3>
    <p>{`Must level up to 5`}<br parentName="p"></br>{`
`}{`Kill 3 Battles > 1 Textbox > `}<strong parentName="p">{`Option 2`}</strong>{` > Turbo`}</p>
    <h3 {...{
      "id": "razril-1"
    }}>{`Razril`}</h3>
    <p>{`Talk to Knight by Ship > Turbo`}</p>
    <h3 {...{
      "id": "world-map-1"
    }}>{`World Map`}</h3>
    <p>{`Go to Middleport`}</p>
    <h3 {...{
      "id": "middleport"
    }}>{`Middleport`}</h3>
    <p>{`Talk to Knight of Gaien by ship > Mash`}</p>
    <h3 {...{
      "id": "world-map-2"
    }}>{`World Map`}</h3>
    <p>{`Swim by Middleport until Damp Hairball`}</p>
    <h4 {...{
      "id": "damp-hairball"
    }}>{`Damp Hairball`}</h4>
    <p>{`Tal Attack`}</p>
    <p>{`Go back to Razril`}</p>
    <h3 {...{
      "id": "razril-2"
    }}>{`Razril`}</h3>
    <p>{`Turbo > `}<strong parentName="p">{`Hall of Knights`}</strong>{` > Mash till Knights leave party > Turbo`}<br parentName="p"></br>{`
`}{`Leave Hall of Knights > Cutscene > Enter & Exit & Enter Hall of Knights > Mash X`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Audience Chamber`}</strong>{` > Talk to Ramada > Mash > Turbo`}</p>
    <h3 {...{
      "id": "world-map-3"
    }}>{`World Map`}</h3>
    <p>{`Head east (to avoid re-entering Razril) > 67.5° > Cutscene > Turbo > Cutscene`}<br parentName="p"></br>{`
`}{`Talk to Snowe > Cutscene > Option 1 > Cutscene x2`}</p>
    <h4 {...{
      "id": "war-battle-pirate-brandeau"
    }}>{`War Battle: Pirate Brandeau`}</h4>
    <p>{`Take Knight of Gaien 2 and 3 for Rune Cannon`}<br parentName="p"></br>{`
`}{`Start the battle`}</p>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <p><strong parentName="p">{`Lazlo`}</strong>{`: 2 Up, 1 Right, Face Right`}</p>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <p><strong parentName="p">{`Lazlo`}</strong>{`: 1 Up, Attack remaining ship`}</p>
    <p>{`Cutscene`}</p>
    <h4 {...{
      "id": "boss-assassin-168hp--pirate-brandeau-180hp"
    }}>{`Boss Assassin (168HP) / Pirate Brandeau (180HP)`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Lazlo Attack Assassin`}</li>
      <li parentName="ul">{`Knight Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Auto`}</li>
    </ul>
    <p>{`Cutscene x4`}</p>
    <h4 {...{
      "id": "duel-brandeau"
    }}>{`Duel: Brandeau`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Lazlo `}<strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Lazlo `}<strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Lazlo `}<strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hah, child's play! Allow me to ...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I will settle this...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't get cocky, boy!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Your attacks are futile... Don't ...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I'll kill you!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I guess I can play a little.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You... cannot defeat me`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Now, I will kill you with a simple...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Victory is mine...`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Cutscene x5 > Turbo > Cutscene`}</p>
    <h3 {...{
      "id": "razril-3"
    }}>{`Razril`}</h3>
    <p>{`Leave your room > Cutscene > Leave Hall of Knights > Cutscene`}<br parentName="p"></br>{`
`}{`Go to Item Shop > Turbo > Talk to Shopkeeper > Turbo > Leave > Turbo`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Hall of Knights (Hallway)`}</strong>{` > Turbo > Mash`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Kitchen`}</strong>{` > Talk to Funghi`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Commander’s Room`}</strong>{` > Cutscene > Option 1 > Cutscene > Mash > Cutscene > Text`}<br parentName="p"></br>{`
`}{`Leave Hallway > Cutscene > Talk to Knights > Option 1 all.`}<br parentName="p"></br>{`
`}{`Exit Courtyard > Talk to Knight left from you.`}</p>
    <h4 {...{
      "id": "battle-retribution"
    }}>{`Battle: Retribution`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: `}<em parentName="li">{`Rune Cannon`}</em>{` - Jewel`}</li>
    </ul>
    <p>{`Start the battle`}</p>
    <h4 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Move Up Max`}</li>
      <li parentName="ul"><strong parentName="li">{`Snowe`}</strong>{`: Standby`}</li>
    </ul>
    <h4 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Move between enemy ships and attack`}</li>
    </ul>
    <p>{`Lots of cutscenes and text, just mash Triangle and X.`}<br parentName="p"></br>{`
`}{`Done mashing when Katarina text in Razril`}</p>
    <h3 {...{
      "id": "razril-4"
    }}>{`Razril`}</h3>
    <p><strong parentName="p">{`Commander’s Chamber`}</strong>{` > Cutscene`}<br parentName="p"></br>{`
`}{`Leave room > Cutscene`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Lazlo's room`}</strong>{` > Sleep > `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Textbox while asleep and when you wake up`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Kitchen`}</strong>{` > Talk to Funghi`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Commander’s Chamber`}</strong>{` > Mash > Cutscene x5`}<br parentName="p"></br>{`
`}{`Leave Room > Cutscene x3 > Mash`}<br parentName="p"></br>{`
`}{`Exit Hall of Knights > Cutscene`}</p>
    <h4 {...{
      "id": "battle-1-1"
    }}>{`Battle 1`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Attack 2`}</li>
      <li parentName="ul"><strong parentName="li">{`Katarina`}</strong>{`: Defend`}</li>
      <li parentName="ul"><strong parentName="li">{`Tal / Keneth`}</strong>{`: Attack 1`}</li>
    </ul>
    <p>{`Cutscene`}</p>
    <h4 {...{
      "id": "battle-2--3"
    }}>{`Battle 2 & 3`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Attack 1`}</li>
      <li parentName="ul"><strong parentName="li">{`Katarina`}</strong>{`: Defend`}</li>
      <li parentName="ul"><strong parentName="li">{`Tal`}</strong>{`: Attack 2`}</li>
      <li parentName="ul"><strong parentName="li">{`Keneth`}</strong>{`: Attack 3`}</li>
    </ul>
    <p>{`After Battle 2 Cutscene`}<br parentName="p"></br>{`
`}{`After Battle 3 Cutscene > Turbo > Cutscene x6 > Mash`}</p>
    <p><strong parentName="p">{`Roof of Hall of Knights Hallway`}</strong>{` > Cutscene x4`}<br parentName="p"></br>{`
`}{`Rune of Punishment > Cutscene > Turbo`}<br parentName="p"></br>{`
`}{`Cutscene x2 > Option 1 > Cutscene x3 > Turbo > Cutscene > Turbo`}</p>
    <h3 {...{
      "id": "world-map-4"
    }}>{`World Map`}</h3>
    <p>{`Fight 2 Battles`}<br parentName="p"></br>{`
`}{`(Alternate Cutscene / Turbo) x3 / Cutscene`}</p>
    <p>{`Talk to Troy > Cutscene`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Cabin`}</strong>{` > Talk to Colton > Option 1`}<br parentName="p"></br>{`
`}{`Exit Cabin > Cutscene x2 > Turbo > Cutscene`}</p>
    <h4 {...{
      "id": "troy--colton"
    }}>{`Troy & Colton`}</h4>
    <p>{`Defend`}</p>
    <p>{`Mash > Cutscene`}</p>
    <h4 {...{
      "id": "battle-x2"
    }}>{`Battle x2`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo / Kenneth`}</strong>{`: Attack 1`}</li>
      <li parentName="ul"><strong parentName="li">{`Tal`}</strong>{`: Attack 2`}</li>
    </ul>
    <p>{`Cutscene x2 > Turbo`}</p>
    <h3 {...{
      "id": "boat"
    }}>{`Boat`}</h3>
    <p>{`Talk to Companions`}</p>
    <h4 {...{
      "id": "random-battle"
    }}>{`Random Battle`}</h4>
    <p>{`Auto`}</p>
    <p>{`Cutscene`}</p>
    <h4 {...{
      "id": "water-dragon-1300hp"
    }}>{`Water Dragon (1300HP)`}</h4>
    <p>{`Chiepoo Defend, rest Attack`}</p>
    <p>{`Cutscene x2`}</p>
    <h3 {...{
      "id": "deserted-island"
    }}>{`Deserted Island`}</h3>
    <p>{`Talk to all companions twice > Turbo`}<br parentName="p"></br>{`
`}{`Check Campsite > Cave 3rd Screen > Escape Talisman > Coconut Area`}<br parentName="p"></br>{`
`}{`Mash > Option 1`}</p>
    <p>{`Do this 3 times`}<br parentName="p"></br>{`
`}{`Choose `}<strong parentName="p">{`Option 2`}</strong>{` to collect rope`}<br parentName="p"></br>{`
`}{`Optimal is to collect rope? Coconuts probably just as good and easier menuing`}<br parentName="p"></br>{`
`}{`Talk to Keneth, Tal, Chiepoo (Doing this before Cave stops them from joining party)`}<br parentName="p"></br>{`
`}{`Go to cave last screen > (3rd time Textbox > Option 1 >) Cutscene > Escape Talisman`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Camp Area`}</strong>{` > `}<strong parentName="p">{`Option 2`}</strong>{` > Mash`}</p>
    <p>{`Cutscene > Talk to Keneth > Cutscene > Mash`}<br parentName="p"></br>{`
`}{`Go to Crab > Cutscene`}</p>
    <h4 {...{
      "id": "boss-crab-1300hp"
    }}>{`Boss Crab (1300HP)`}</h4>
    <p>{`Attack small crabs with Lazlo & Keneth`}<br parentName="p"></br>{`
`}{`Defend for 3 turns`}</p>
    <p>{`Mash > Option 1`}<br parentName="p"></br>{`
`}{`Cutscene`}</p>
    <h4 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo / Tal`}</strong>{`: Attack Boss Crab`}</li>
      <li parentName="ul"><strong parentName="li">{`Keneth`}</strong>{`: Blazing Wall`}</li>
    </ul>
    <h4 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h4>
    <p>{`Auto if all small crabs dead`}</p>
    <p>{`Cutscene > Rune of Punishment Segment > Cutscene > Mash > Cutscene`}<br parentName="p"></br>{`
`}{`Talk to Keneth > Option 1`}<br parentName="p"></br>{`
`}{`Cutscene > Mash`}</p>
    <h3 {...{
      "id": "world-map-5"
    }}>{`World Map`}</h3>
    <p>{`2 Battles > Auto`}</p>
    <h3 {...{
      "id": "twin-rays-850900hp"
    }}>{`Twin Rays (850/900HP)`}</h3>
    <h4 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo / Tal`}</strong>{`: Attack 1`}</li>
      <li parentName="ul"><strong parentName="li">{`Keneth`}</strong>{`: Blazing Wall`}</li>
    </ul>
    <h4 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h4>
    <p>{`Chiepoo Defend, rest Attack.`}</p>
    <p>{`Talk to Companions`}<br parentName="p"></br>{`
`}{`Cutscene x2 > Turbo > Option 1 > Cutscene`}<br parentName="p"></br>{`
`}{`Enter and exit cabin > Talk to Desmond twice`}<br parentName="p"></br>{`
`}{`Cutscene > Turbo`}</p>
    <h3 {...{
      "id": "obel"
    }}>{`Obel`}</h3>
    <p>{`Take the path to the blacksmith`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "blacksmith"
      }}>{`Blacksmith`}</h5>
      <p>{`Sharpen everyone but Chiepoo’s to 6`}</p>
      <h5 {...{
        "id": "rune-shop"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Lightning > Chiepoo`}</li>
        <li parentName="ul">{`Mother Earth > Lazlo`}</li>
        <li parentName="ul">{`Double Strike > Keneth`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Palace`}</strong>{` > Talk to Setsu > Turbo > Cutscene x4 > Prompt > Turbo`}<br parentName="p"></br>{`
`}{`Leave the palace > Turbo > Cutscene > Prompt`}</p>
    <p><strong parentName="p">{`Ruins`}</strong>{` > Talk to Rakgi > Turbo > Prompt`}</p>
    <h3 {...{
      "id": "obel-ruins"
    }}>{`Obel Ruins`}</h3>
    <p>{`Mash text top of 1st stair room`}</p>
    <h4 {...{
      "id": "boss-guard-1500hp"
    }}>{`Boss Guard (1500HP)`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Earthquake`}</li>
      <li parentName="ul"><strong parentName="li">{`Chiepoo`}</strong>{`: Defend`}</li>
      <li parentName="ul"><strong parentName="li">{`Tal / Keneth`}</strong>{`: Attack`}</li>
    </ul>
    <p>{`Talk to Rikie > Turbo > Prompt`}<br parentName="p"></br>{`
`}{`Cutscene x2 > Option 1 > Turbo`}<br parentName="p"></br>{`
`}{`Go back towards the ruins > Textbox > Cutscene`}</p>
    <h4 {...{
      "id": "boss-guard-2000hp"
    }}>{`Boss Guard (2000HP)`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo / Tal / Keneth`}</strong>{`: Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Chiepoo`}</strong>{`: Defend`}</li>
    </ul>
    <p>{`Turbo > Prompt`}</p>
    <h3 {...{
      "id": "obel-1"
    }}>{`Obel`}</h3>
    <p>{`Go to your HQ > Turbo > Prompt`}<br parentName="p"></br>{`
`}{`Cutscene > Turbo > Cutscene > Prompts > Turbo > Option 1 > Turbo > Prompts`}</p>
    <p>{`Go to bed > Skip Cutscene`}<br parentName="p"></br>{`
`}{`Go down stairs to 2nd floor > Talk to Desmond Twice`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Add Tal`}</li>
        <li parentName="ul">{`Add Keneth`}</li>
      </ul>
    </Menu>
    <p>{`Leave HQ > Turbo > Cutscene`}</p>
    <p>{`Talk to Manu > Turbo > Option 1`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Ornan`}</strong></p>
    <p>{`Talk to NPC at Ship > Mash`}<br parentName="p"></br>{`
`}{`Turbo > Cutscene > Turbo > Prompt`}</p>
    <h3 {...{
      "id": "world-map-6"
    }}>{`World Map`}</h3>
    <p>{`Go to massive White Dot`}<br parentName="p"></br>{`
`}{`Cutscene > Mash > Option 1 > Cutscene`}</p>
    <h4 {...{
      "id": "pirate-battle-1--2"
    }}>{`Pirate Battle 1 & 2`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Attack 1`}</li>
      <li parentName="ul"><strong parentName="li">{`Tal`}</strong>{`: Attack 3`}</li>
      <li parentName="ul"><strong parentName="li">{`Keneth`}</strong>{`: Attack 2`}</li>
    </ul>
    <p>{`Cutscene / Mash (`}<strong parentName="p">{`Option 2`}</strong>{` saves a CS, bit more mashing)`}</p>
    <p><strong parentName="p">{`Obel`}</strong>{` > Turbo`}</p>
    <h4 {...{
      "id": "war-battle-pirate-dario"
    }}>{`War Battle: Pirate Dario`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: `}<em parentName="li">{`Rune Cannon`}</em>{` - Chiepoo. `}<em parentName="li">{`Fighters`}</em>{` - Keneth`}</li>
    </ul>
    <p>{`Start the battle`}</p>
    <h4 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h4>
    <p>{`Standby`}</p>
    <h4 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h4>
    <p>{`2 Left, Attack with Chiepoo. Counter with Chiepoo & attack with Chiepoo again.`}</p>
    <p>{`Turbo > Cutscene x3 > Turbo > Cutscene > Turbo`}</p>
    <p>{`Go to `}<strong parentName="p">{`Obel`}</strong>{` > Textbox`}</p>
    <h3 {...{
      "id": "obel-2"
    }}>{`Obel`}</h3>
    <p>{`Talk to innkeeper > Cutscene`}<br parentName="p"></br>{`
`}{`Talk to NPC by Stairs > Option 1 > Turbo > head to HQ`}<br parentName="p"></br>{`
`}{`Cutscene first 3 screen transitions > Text box next 2`}<br parentName="p"></br>{`
`}{`Talk to Louise > Turbo > Prompt`}<br parentName="p"></br>{`
`}{`Talk to Desmond > Turbo`}</p>
    <p>{`Leave HQ > Cutscene / Mash > Talk to Manu > Get on Ship > Cutscene`}</p>
    <h3 {...{
      "id": "world-map-7"
    }}>{`World Map`}</h3>
    <p>{`Go east then North slightly east ~5°`}</p>
    <h3 {...{
      "id": "nay"
    }}>{`Nay`}</h3>
    <p>{`Take right path to Oleg > Talk to Oleg > Option 1 > Cutscene > Prompt`}<br parentName="p"></br>{`
`}{`Talk to innkeeper`}<br parentName="p"></br>{`
`}{`Try to Exit room > Cutscene x3 > Turbo`}<br parentName="p"></br>{`
`}{`Go to sleep`}<br parentName="p"></br>{`
`}{`Return to the camera > Cutscene x3 > Take right path`}<br parentName="p"></br>{`
`}{`Return to port > go to the shore > Cutscene > Turbo`}<br parentName="p"></br>{`
`}{`Get back on Ship`}</p>
    <h3 {...{
      "id": "world-map-8"
    }}>{`World Map`}</h3>
    <p>{`Go South, very slightly west`}</p>
    <h3 {...{
      "id": "obel-3"
    }}>{`Obel`}</h3>
    <p><strong parentName="p">{`Audience Chamber`}</strong>{` > Cutscene > Prompts`}<br parentName="p"></br>{`
`}{`Go towards HQ, Cliff Path screen 2 Cutscene`}</p>
    <h4 {...{
      "id": "akaghi--mizuki-600hp"
    }}>{`Akaghi & Mizuki (600HP)`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Earthquake`}</li>
      <li parentName="ul">{`Rest: Defend`}</li>
    </ul>
    <p>{`Cutscene x2 > Prompt > Go to the palace > Textbox > Turbo > Prompts`}<br parentName="p"></br>{`
`}{`Leave Audience Chamber > Cutscene`}<br parentName="p"></br>{`
`}{`Go back towards HQ > Cutscene x4`}<br parentName="p"></br>{`
`}{`Option 1 > Cutscene x5`}</p>
    <h4 {...{
      "id": "war-battle-defending-obel"
    }}>{`War Battle: Defending Obel`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: `}<em parentName="li">{`Rune Cannon`}</em>{` - Chiepoo.`}</li>
      <li parentName="ul"><strong parentName="li">{`Lino`}</strong>{`: `}<em parentName="li">{`Underlings`}</em>{` - Remove at least 6 Underlings.`}</li>
    </ul>
    <p>{`Start the battle`}</p>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: 1 Up 1 Left, Face Right`}</li>
      <li parentName="ul"><strong parentName="li">{`Lino`}</strong>{`: 3 Right, Face Up`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Lino`}</strong>{`: 4 Up, Attack Fire`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: 3 Right, Attack`}</li>
    </ul>
    <p>{`Cutscene > Rune of Punishment > Cutscene x2`}</p>
    <h3 {...{
      "id": "headquarters"
    }}>{`Headquarters`}</h3>
    <p>{`Leave HQ > Cutscene`}<br parentName="p"></br>{`
`}<strong parentName="p">{`War Room`}</strong>{` > Cutscene x2 > Prompt`}<br parentName="p"></br>{`
`}{`Leave HQ > Cutscene > Turbo > Cutscene > `}<strong parentName="p">{`Obel`}</strong></p>
    <h3 {...{
      "id": "obel-4"
    }}>{`Obel`}</h3>
    <p>{`First screen after palace talk to NPC in front of the Rune Shop > Cutscene x3`}<br parentName="p"></br>{`
`}{`Talk to women in light clothing by Laundry > Cutscene x2`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Yu`}</strong>{` & `}<strong parentName="p">{`Adrienne`}</strong><br parentName="p"></br>{`
`}{`Talk to NPC at end of port (furthest, on the right)`}</p>
    <p>{`Return to HQ`}<br parentName="p"></br>{`
`}{`Cliff Path > Cutscene > `}<strong parentName="p">{`War Room`}</strong><br parentName="p"></br>{`
`}{`Cutscene > Option 1 > Cutscene x? > Option 1 > Cutscene x11`}</p>
    <h3 {...{
      "id": "obel-ship"
    }}>{`Obel Ship`}</h3>
    <p>{`Go to Saloon (Closest Door) > Cutscene x3`}</p>
    <h3 {...{
      "id": "world-map-9"
    }}>{`World Map`}</h3>
    <p>{`Go to Mordo (West until North possible then North)`}</p>
    <h3 {...{
      "id": "mordo-island"
    }}>{`Mordo Island`}</h3>
    <p>{`Exit right away`}</p>
    <h3 {...{
      "id": "world-map-10"
    }}>{`World Map`}</h3>
    <p>{`Go to Nay ~22.5°`}</p>
    <h3 {...{
      "id": "nay-1"
    }}>{`Nay`}</h3>
    <p>{`Go to Kobold Colony`}<br parentName="p"></br>{`
`}{`Cutscene Viki`}<br parentName="p"></br>{`
`}{`Enter Kobold Colony > Recruit `}<strong parentName="p">{`Bang`}</strong><br parentName="p"></br>{`
`}{`Go to Trade Shop > Recruit `}<strong parentName="p">{`Perrault`}</strong><br parentName="p"></br>{`
`}{`Exit Kobold Colony > Recruit `}<strong parentName="p">{`Viki`}</strong><br parentName="p"></br>{`
`}{`Use Glowing Hand Mirror`}</p>
    <h3 {...{
      "id": "world-map-11"
    }}>{`World Map`}</h3>
    <p>{`Go to Na-Nal (Southeast ~112.5°)`}</p>
    <h3 {...{
      "id": "na-nal"
    }}>{`Na-Nal`}</h3>
    <p>{`Go to inn > Recruit `}<strong parentName="p">{`Manu`}</strong><br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Rita`}</strong>{` > `}<strong parentName="p">{`Option 2`}</strong>{` to play, Option 1 to recruit`}<br parentName="p"></br>{`
`}{`Talk to the man in the bath area (1st left path)`}<br parentName="p"></br>{`
`}{`Talk to the man by the armor shop (Same screen as Rune shop on right)`}<br parentName="p"></br>{`
`}{`Go to Rune Shop`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to talk to Jeane > Cutscene`}<br parentName="p"></br>{`
`}{`Option 3 to recruit Jeane`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "rune-shop-1"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Rage > Jeane`}</li>
        <li parentName="ul">{`Thunder > Viki`}</li>
        <li parentName="ul">{`Wizard > Jeane`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Magic Ring (Optional)`}</li>
        <li parentName="ul"><strong parentName="li">{`Viki`}</strong>{`: Best Equip`}</li>
        <li parentName="ul"><strong parentName="li">{`Jeane`}</strong>{`: Best Equip > Jeane `}<em parentName="li">{`(Hat of Wisdom, Ninja Garb, Bondage Glove, Magic Sandals, 3 Speed Ring)`}</em></li>
        <li parentName="ul"><strong parentName="li">{`Viki`}</strong>{`: 2 Magic Rings `}<em parentName="li">{`(Hat of Wisdom, RotD, Magic Sandals, Magic Hands, 2 Magic Rings, 1 Thunder Magic Ring)`}</em></li>
      </ul>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Mixed Herbs on Lazlo`}</li>
        <li parentName="ul">{`Glowing Hand Mirror`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to Mordo (1|5)`}</p>
    <h3 {...{
      "id": "mordo"
    }}>{`Mordo`}</h3>
    <p>{`Get on ship`}</p>
    <h3 {...{
      "id": "world-map-12"
    }}>{`World Map`}</h3>
    <p><strong parentName="p">{`Nest of Pirates`}</strong>{` (directly Southwest ~225°)`}</p>
    <h3 {...{
      "id": "nest-of-pirates"
    }}>{`Nest of Pirates`}</h3>
    <p>{`Cutscene > Turbo`}<br parentName="p"></br>{`
`}{`Enter Hideout > Cutscene`}<br parentName="p"></br>{`
`}{`Talk to Kika > Turbo > Cutscene > Option 1 > Cutscene > Turbo > Prompts`}</p>
    <p>{`Get on boat (faster to talk to Rakgi) and re-enter`}</p>
    <p>{`Turbo > Cutscene > Turbo > Option 1`}</p>
    <p>{`Leave the room`}<br parentName="p"></br>{`
`}{`Turbo > Cutscene`}</p>
    <p>{`Talk to Rakgi to get back on boat`}<br parentName="p"></br>{`
`}{`Cutscene x2 > Turbo > Cutscene > Turbo`}</p>
    <h4 {...{
      "id": "war-battle-former-friend-note-look-into-haruto-strat"
    }}>{`War Battle: Former Friend (note, look into Haruto strat)`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: `}<em parentName="li">{`Rune Cannon`}</em>{` - Replace Nalleo w/ Viki, Add Pablo. `}<em parentName="li">{`Underlings`}</em>{` - Remove Sigurd, Hervey`}</li>
    </ul>
    <p>{`Start the battle`}</p>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: 3 Up, Face Right`}</li>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Surrender`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: 1 Right, Rune Cannon x2`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: 3? Right, Rune Cannon, then counter w/ Viki`}</li>
    </ul>
    <p>{`Cutscene > Textbox`}</p>
    <h3 {...{
      "id": "world-map-13"
    }}>{`World Map`}</h3>
    <p>{`Go Northwest to Razril ~335°`}<br parentName="p"></br>{`
`}{`Look for LVL up battle, prefer battle with 3 Ice Birds or 4 Killer Fish. Any fight >= 2 Ice Birds will do though. Better to do it now. Kill it with Explosion.`}</p>
    <h3 {...{
      "id": "razril-5"
    }}>{`Razril`}</h3>
    <p>{`Cutscene x7`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 3`}</strong>{` > Snowe`}<br parentName="p"></br>{`
`}{`Cutscene > Turbo`}<br parentName="p"></br>{`
`}{`Use Glowing Hand Mirror > Teleport to Nest of Pirates (1|1)`}</p>
    <h3 {...{
      "id": "nest-of-pirates-1"
    }}>{`Nest of Pirates`}</h3>
    <p>{`Talk to Rakgi to leave`}</p>
    <h3 {...{
      "id": "world-map-14"
    }}>{`World Map`}</h3>
    <p>{`Go to Hermitage Island`}</p>
    <h3 {...{
      "id": "hermitage-island"
    }}>{`Hermitage Island`}</h3>
    <p>{`Go to Elenor’s > Turbo`}<br parentName="p"></br>{`
`}{`Cutscene x2 > Turbo > Cutscene x2 > Option 1 > Cutscene`}<br parentName="p"></br>{`
`}{`Leave towards Cave`}</p>
    <h4 {...{
      "id": "behemoth-700hp"
    }}>{`Behemoth (700HP)`}</h4>
    <p>{`Earthquake, Auto if it doesn’t kill (Damage roll, equipping Magic Ring = ~90% chance of one shot.)`}</p>
    <p>{`Go into cave and pick up stuff at end`}<br parentName="p"></br>{`
`}{`Talk to Agnes > Turbo > Prompts`}<br parentName="p"></br>{`
`}{`Cutscene > Option 1 > Turbo`}</p>
    <p>{`Leave Elenor’s House > Textbox > Prompt`}<br parentName="p"></br>{`
`}{`Pick up Copper Hammer in chest`}<br parentName="p"></br>{`
`}{`Run back to boat > Cutscene`}</p>
    <h3 {...{
      "id": "world-map-15"
    }}>{`World Map`}</h3>
    <p>{`Glowing Hand Mirror`}</p>
    <h3 {...{
      "id": "obel-ship-1"
    }}>{`Obel Ship`}</h3>
    <p>{`Go to War Room > Cutscene x2`}</p>
    <p><strong parentName="p">{`!!!IMPORTANT!!!`}</strong>{` Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Cutscene > Turbo, 2 Option 1s then `}<strong parentName="p">{`Option 2`}</strong>{` > Cutscene x2`}</p>
    <p>{`Glowing Hand Mirror > Talk to Desmond`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Keneth`}</li>
        <li parentName="ul">{`Jeane`}</li>
        <li parentName="ul">{`Viki`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Jeane HAS to be in the formation before Viki. Rune Unites use the speed of the character who initiated it, which will be the one earlier in the formation.`}</p>
      </blockquote>
    </Menu>
    <p>{`War Room > Turbo > Option 1`}<br parentName="p"></br>{`
`}{`Depart`}</p>
    <h3 {...{
      "id": "world-map-16"
    }}>{`World Map`}</h3>
    <p>{`Head towards Middleport (Northwest 337.5°)`}<br parentName="p"></br>{`
`}{`Look for another level up battle if you haven’t gotten one yet, note that you will have to heal if you do it now. Might be able to just use Mixed Herbs. Kill it with Explosion`}</p>
    <h3 {...{
      "id": "middleport-1"
    }}>{`Middleport`}</h3>
    <p>{`Cutscene x2`}</p>
    <h4 {...{
      "id": "moving-island-3500hp"
    }}>{`Moving Island (3500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Earthquake`}</li>
      <li parentName="ul"><strong parentName="li">{`Jeane`}</strong>{`: Flame Array Moving Island`}</li>
    </ul>
    <p>{`Turbo`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-2"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Lino`}</li>
        <li parentName="ul">{`Kika`}</li>
        <li parentName="ul">{`Hervey`}</li>
      </ul>
    </Menu>
    <p>{`Cutscene > `}<strong parentName="p">{`Option 2`}</strong>{` (little bit faster) > Turbo`}<br parentName="p"></br>{`
`}{`Go to Reinback Mansion > Cutscene`}<br parentName="p"></br>{`
`}{`Turbo Reinback II > Option 1, `}<strong parentName="p">{`Option 2`}</strong>{`, Option 1 > Prompts > Turbo`}</p>
    <p>{`Talk to Rakgi, Cutscene > Option 1 > Cutscene`}<br parentName="p"></br>{`
`}{`Glowing Hand Mirror, do not talk to Rakgi (Discard Ocean Piece)`}</p>
    <h3 {...{
      "id": "the-chicken"
    }}>{`The Chicken`}</h3>
    <p>{`Teleport to Nay Island (3)`}</p>
    <h3 {...{
      "id": "nay-2"
    }}>{`Nay`}</h3>
    <p>{`Go talk to Village Chief > Mash > Glowing Hand Mirror`}</p>
    <h3 {...{
      "id": "the-chicken-1"
    }}>{`The Chicken`}</h3>
    <p>{`Go to 3rd floor and do this menu. Can also do it before departing to Na-Nal.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "rune-shop-2"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Double-Strike: Lino, Kika, Hervey, Lazlo`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith-1"
      }}>{`Blacksmith`}</h5>
      <p>{`Sharpen party to max.`}</p>
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Lino`}</strong>{`, `}<strong parentName="li">{`Kika`}</strong>{`, `}<strong parentName="li">{`Hervey`}</strong>{`: Best Equip`}</li>
        <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Ogre Boots, Power Ring`}</li>
        <li parentName="ul"><strong parentName="li">{`Lino`}</strong>{`: Ogre Boots, 3x Power Ring`}</li>
      </ul>
      <p>{`Depart`}</p>
    </Menu>
    <p>{`Re-enter Nay (Face straight left)`}</p>
    <h3 {...{
      "id": "nay-3"
    }}>{`Nay`}</h3>
    <p>{`Go to Chief’s house > Turbo > Option 1 > Turbo > Prompts`}<br parentName="p"></br>{`
`}{`Glowing Hand Mirror > Depart (Can also do menu here)`}</p>
    <h3 {...{
      "id": "world-map-17"
    }}>{`World Map`}</h3>
    <p><strong parentName="p">{`Na-Nal`}</strong>{` > Turbo`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Kika`}</li>
        <li parentName="ul">{`Hervey`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "na-nal-1"
    }}>{`Na-Nal`}</h3>
    <h4 {...{
      "id": "fights-with-groups-of-3"
    }}>{`Fights with groups of 3`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Attack 2`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Attack 3`}</li>
      <li parentName="ul"><strong parentName="li">{`Lino / Hervey`}</strong>{`: Attack 1`}</li>
    </ul>
    <p>{`Cutscene`}<br parentName="p"></br>{`
`}{`Turbo > Cutscene > Turbo`}</p>
    <p>{`Talk to bed > Turbo`}<br parentName="p"></br>{`
`}{`Closest path on right towards Elves`}</p>
    <p>{`Cutscene > Take remedy`}<br parentName="p"></br>{`
`}{`Cutscene > Mash > Cutscene > Prompt`}</p>
    <p>{`Go towards Port > Cutscene x2 > Option 1 > Cutscene x2`}<br parentName="p"></br>{`
`}{`Talk to people in cell > Cutscene`}<br parentName="p"></br>{`
`}{`Return to Village`}<br parentName="p"></br>{`
`}{`Cutscene > Fights > Cutscene > Turbo > Option 1 > Turbo > Prompts > Turbo`}</p>
    <p>{`Glowing Hand Mirror`}</p>
    <h3 {...{
      "id": "the-chicken-2"
    }}>{`The Chicken`}</h3>
    <p>{`Talk to Desmond`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Keneth`}</li>
        <li parentName="ul">{`Jeane`}</li>
        <li parentName="ul">{`Viki`}</li>
      </ul>
    </Menu>
    <p>{`Go to War Room > Turbo > Option 1 > Turbo`}</p>
    <p><strong parentName="p">{`Go to 3rd Floor`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "rune-shop-3"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Thunder Rune: Jeane, replace Rage Rune`}</li>
        <li parentName="ul">{`Warrior Rune: Keneth`}</li>
        <li parentName="ul">{`Wizard Rune: Viki`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith-2"
      }}>{`Blacksmith`}</h5>
      <p>{`Sharpen Keneth to max`}</p>
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Keneth`}</strong>{`: Swap Power Rings for Speed Rings`}</li>
        <li parentName="ul"><strong parentName="li">{`Viki`}</strong>{`: Best Equip`}</li>
      </ul>
      <p>{`Glowing Hand Mirror`}</p>
    </Menu>
    <p>{`Teleport to Middleport (2)`}</p>
    <h3 {...{
      "id": "middleport-2"
    }}>{`Middleport`}</h3>
    <p>{`Talk to Rakgi to get on boat`}</p>
    <h3 {...{
      "id": "world-map-18"
    }}>{`World Map`}</h3>
    <p>{`Go towards Razril`}<br parentName="p"></br>{`
`}{`Cutscene > Turbo > `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-regaining-razril"
    }}>{`War Battle: Regaining Razril`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: `}<em parentName="li">{`Fighters`}</em>{` - Add Lino, Tal, Keneth, Hervey`}</li>
    </ul>
    <p>{`Start Battle`}</p>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Surrender`}</li>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: 1 Right 3 Up, Face Up`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Max Up, Board. Attack 1-4 manually.`}</li>
    </ul>
    <p>{`Cutscene > Option 1 > Cutscene > Mash > Turbo`}</p>
    <h3 {...{
      "id": "razril-6"
    }}>{`Razril`}</h3>
    <p>{`Cutscene > Turbo > Option 1 > Turbo > Prompts`}<br parentName="p"></br>{`
`}{`Talk to relevant NPCs (Need to recruit 7)`}</p>
    <ol>
      <li parentName="ol">{`Razril Main Street: first man on right`}</li>
      <li parentName="ol">{`Razril Main Street: top woman in middle left of alleyway`}</li>
      <li parentName="ol">{`Razril Port: woman closest to Hall of Knights`}</li>
      <li parentName="ol">{`Hall of Knights: man right where we enter`}</li>
      <li parentName="ol">{`Hall of Knights: man in the furthest right of half circle group`}</li>
      <li parentName="ol">{`Hall of Knights Courtyard: woman by Audience Chamber`}</li>
      <li parentName="ol">{`Hall of Knights Courtyard: woman in northwest part of area`}</li>
    </ol>
    <p><strong parentName="p">{`Training Hall`}</strong>{` > Cutscene > Option 1 > Cutscene x2`}</p>
    <h5 {...{
      "id": "fight"
    }}>{`Fight`}</h5>
    <p>{`Lazlo, Jeane Attack 1, Keneth Attack 2`}</p>
    <p>{`Cutscene x2 > Turbo > Cutscene`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Boat in Razril Port`}</strong>{` > Turbo`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Hallway`}</strong>{` > Sleep in your room`}<br parentName="p"></br>{`
`}{`Glowing Hand Mirror`}</p>
    <h3 {...{
      "id": "the-chicken-3"
    }}>{`The Chicken`}</h3>
    <p>{`Teleport to Hermitage Island (R2D)`}</p>
    <h3 {...{
      "id": "hermitage-island-1"
    }}>{`Hermitage Island`}</h3>
    <p>{`Talk to Rakgi`}</p>
    <h3 {...{
      "id": "world-map-19"
    }}>{`World Map`}</h3>
    <p>{`Go to Nest of Pirates`}</p>
    <h3 {...{
      "id": "nest-of-pirates-2"
    }}>{`Nest of Pirates`}</h3>
    <p>{`Enter Bar`}<br parentName="p"></br>{`
`}{`Cutscene > Prompt > Turbo > Option 1 > Turbo > Cutscene > Turbo > Cutscene`}<br parentName="p"></br>{`
`}{`Glowing Hand Mirror`}</p>
    <h3 {...{
      "id": "the-chicken-4"
    }}>{`The Chicken`}</h3>
    <p>{`Teleport to Mordo Island (R5D)`}</p>
    <h3 {...{
      "id": "mordo-island-1"
    }}>{`Mordo Island`}</h3>
    <p>{`Talk to Rakgi`}</p>
    <h3 {...{
      "id": "world-map-20"
    }}>{`World Map`}</h3>
    <p>{`Go towards Obel`}<br parentName="p"></br>{`
`}{`Cutscene x3 > Turbo > Cutscene`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` => Grishend`}</p>
    <h3 {...{
      "id": "war-battle-for-obels-freedom"
    }}>{`War Battle: For Obel’s Freedom`}</h3>
    <p>{`Axel as captain for last ship > Start Button to start`}<br parentName="p"></br>{`
`}{`Cutscene`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong><ul parentName="li">
          <li parentName="ul"><em parentName="li">{`Captain`}</em>{`: Remove Lazlo`}</li>
          <li parentName="ul"><em parentName="li">{`Rune Cannon`}</em>{`: Add Jeane, Chiepoo (for underlings in Final Battle)`}</li>
          <li parentName="ul"><em parentName="li">{`Fighters`}</em>{`: Remove Lino, Keneth`}</li>
          <li parentName="ul"><em parentName="li">{`Underlings`}</em>{`: Reduce to 29`}</li>
          <li parentName="ul"><em parentName="li">{`Captain`}</em>{`: Lazlo`}</li>
        </ul></li>
    </ul>
    <p>{`Start the battle`}</p>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Max Up`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: 4 Up, Attack w/ Jeane`}</li>
      <li parentName="ul">{`Turbo after Lazlo attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika, Axel`}</strong>{`: Surrender`}</li>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Attack w/ Jeane`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`If you didn't kill with counter Lazlo move up and attack`}</li>
    </ul>
    <p>{`Cutscene > Turbo > Cutscene x4 > Option 1`}</p>
    <h3 {...{
      "id": "war-battle-mysterious-fleet"
    }}>{`War Battle: Mysterious Fleet`}</h3>
    <p>{`Start Battle`}</p>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Surrender`}</li>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Max Up`}</li>
      <li parentName="ul"><strong parentName="li">{`Axel`}</strong>{`: Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Max Up, Attack w/ Jeane`}</li>
    </ul>
    <p>{`Cutscene x2 > Option 1 > Cutscene x5 > Turbo > Cutscene > RoP > Cutscene`}</p>
    <h3 {...{
      "id": "the-chicken-5"
    }}>{`The Chicken`}</h3>
    <p>{`Exit room > Take stairs up > Take door to deck > Cutscene`}<br parentName="p"></br>{`
`}{`Glowing Hand Mirror > Go to War Room`}<br parentName="p"></br>{`
`}{`Cutscene > Turbo > `}<strong parentName="p">{`Option 2`}</strong>{` > Turbo > Option 1 > Turbo > Cutscene`}</p>
    <p>{`Talk to Elenor > Option 1 > Turbo`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "seperate-task-force"
      }}>{`Seperate Task Force`}</h5>
      <ul>
        <li parentName="ul">{`Lino`}</li>
        <li parentName="ul">{`Keneth`}</li>
        <li parentName="ul">{`Viki`}</li>
      </ul>
    </Menu>
    <p>{`Turbo > Option 1 > Textbox > Go to room > Sleep`}<br parentName="p"></br>{`
`}{`Glowing Hand Mirror > Go to War Room`}<br parentName="p"></br>{`
`}{`Talk to Eleanor > `}<strong parentName="p">{`Option 3`}</strong><br parentName="p"></br>{`
`}{`Cutscene > Option 1 > Cutscene x2 > Turbo`}</p>
    <p>{`Go closest door > 1st floor > Your room > Sleep`}<br parentName="p"></br>{`
`}{`Cutscene x2`}</p>
    <p>{`Exit Room > Take stairs up > Deck > Cutscene > Turbo > Option 1 > Turbo`}</p>
    <h3 {...{
      "id": "fort-del-eal"
    }}>{`Fort d’El-Eal`}</h3>
    <p>{`Turbo > Move forward`}<br parentName="p"></br>{`
`}{`Cutscene x6 > Turbo > Cutscene x4`}</p>
    <h3 {...{
      "id": "war-battle-final-engagement-review-vod"
    }}>{`War Battle: Final Engagement (Review VOD)`}</h3>
    <h5 {...{
      "id": "kika"
    }}>{`Kika`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Captain`}</em>{`: Sigurd`}</li>
      <li parentName="ul"><em parentName="li">{`Fighters`}</em>{`: Add Flare`}</li>
    </ul>
    <h5 {...{
      "id": "kika-1"
    }}>{`Kika`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Captain`}</em>{`: Haruto`}</li>
      <li parentName="ul"><em parentName="li">{`Fighters`}</em>{`: Add Lazlo, Kika`}</li>
    </ul>
    <h5 {...{
      "id": "obel-ship-2"
    }}>{`Obel Ship`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Captain`}</em>{`: Nalleo`}</li>
    </ul>
    <p>{`Start Battle`}</p>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Sigurd`}</strong>{`: 3 Up, Face Right`}</li>
      <li parentName="ul"><strong parentName="li">{`Haruto`}</strong>{`: 1 Right 2 Up, Face Up`}</li>
      <li parentName="ul"><strong parentName="li">{`Axel`}</strong>{`: Surrender`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Sigurd`}</strong>{`: 2 Right, Face Right`}</li>
      <li parentName="ul"><strong parentName="li">{`Nalleo`}</strong>{`: Surrender`}</li>
      <li parentName="ul"><strong parentName="li">{`Haruto`}</strong>{`: 4 Up, Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Sigurd`}</strong>{`: Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Haruto`}</strong>{`: 1 Up, 3 Right, Board (Attack 1-4)`}</li>
      <li parentName="ul"><em parentName="li">{`If other ship survived, move min right and Attack. Next turn board.`}</em></li>
    </ul>
    <h3 {...{
      "id": "fort-el-eal"
    }}>{`Fort El-Eal`}</h3>
    <p>{`1st person recommended for moving`}<br parentName="p"></br>{`
`}{`Enemies are stronger on 3rd and 4th floors, better for leveling`}<br parentName="p"></br>{`
`}{`Don’t need level up with 1st party.`}</p>
    <p>{`Second party I kill 1 group of 3, preferably on staircase`}</p>
    <p>{`Enter fort > Turbo`}<br parentName="p"></br>{`
`}{`Go to 4th floor -> Enter door at end of room -> Cutscene`}</p>
    <p>{`Cray has 130 SPD, Keneth needs to have more. He should with 3 Speed Rings.`}</p>
    <h3 {...{
      "id": "graham-cray-4000hp"
    }}>{`Graham Cray (4000HP)`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lino / Keneth`}</strong>{`: Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Viki`}</strong>{`: Heavenly Thunder`}</li>
    </ul>
    <p>{`Cutscene > Turbo > Cutscene`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Kika`}</li>
        <li parentName="ul">{`Jeane`}</li>
        <li parentName="ul">{`Hervey`}</li>
      </ul>
    </Menu>
    <p>{`Go to Cray’s Room, pick up key on desk.`}<br parentName="p"></br>{`
`}{`If you did 2 level up battles and think Jeane might have a 2nd lvl4 spell, can rest on couch`}</p>
    <p>{`Go to 2nd floor > Stairs > Go up and enter door`}</p>
    <p>{`Cutscene > Option 1 > Cutscene > Option 1 > Cutscene x2`}</p>
    <h4 {...{
      "id": "giant-tree-13000hp"
    }}>{`Giant Tree (13000HP)`}</h4>
    <h5 {...{
      "id": "all-turns"
    }}>{`All Turns`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: Attack Giant Tree`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Falcon Giant Tree`}</li>
      <li parentName="ul"><strong parentName="li">{`Hervey`}</strong>{`: Attack Giant Tree`}</li>
      <li parentName="ul"><strong parentName="li">{`Jeane`}</strong>{`: Best Magic Giant Tree`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If party low can use Eternal Ordeal, note that Lazlo gets outsped.`}<br parentName="p"></br>{`
`}{`If Lazlo low or tree charging white, can use Rush to heal/skip?`}<br parentName="p"></br>{`
`}{`If people fall asleep can use Special Lunch to cure`}</p>
    </blockquote>
    <p>{`Cutscene`}</p>
    <p>{`Exit Fort, 2 forced battles by stairs and door you can bribe.`}<br parentName="p"></br>{`
`}{`Go to boat and talk to Rakgi`}</p>
    <p>{`Cutscene`}</p>
    <h4 {...{
      "id": "duel-troy"
    }}>{`Duel: Troy`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Lazlo `}<strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Lazlo `}<strong parentName="th">{`Guard`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Lazlo `}<strong parentName="th">{`Special`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`......`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I'll  settle this with the next move.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Here I go.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Come at me.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Prepare yourself.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Then... here I go.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Come on! Let's see what you have got`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sorry... but I will take your life...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yield to my sword...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Humph...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Cutscene > Option 1 > Cutscene x9 > Option 1 > Cutscene >  RoP > Cutscene x6 > Done!`}</p>
    <p>{`GG !!!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      